// extracted by mini-css-extract-plugin
export default {"rotate":"LocationsPage_rotate__YadBx"};